module.exports = __webpack_public_path__ + "static/image/luhu.svg?2d848f3eee95dd406ad1ae53ec3a6052";